import { render, staticRenderFns } from "./ChangeCardsWithSlogan.vue?vue&type=template&id=a1b89828&scoped=true"
import script from "./ChangeCardsWithSlogan.vue?vue&type=script&lang=js"
export * from "./ChangeCardsWithSlogan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1b89828",
  null
  
)

export default component.exports